import { IIsEmptySettings } from './interfaces'

export const isEmpty = (
  value: string | [] | object | null | undefined,
  settings: IIsEmptySettings = {}
): Promise<string> => {
  let result
  const valueToValidate = value + ''
  if (value instanceof Array) {
    result = !value.length
  } else if (value === null || value === undefined) {
    result = true
  } else if (typeof value === 'object') {
    result = !Object.keys(value).length
  } else {
    if (settings.withHTML) {
      result = !valueToValidate.replace(/(\<(\/?[^>]+)>|&nbsp;)/g, '').trim().length
    } else {
      result = !valueToValidate.trim().length
    }
  }

  return Promise.resolve(result ? 'Field must not be empty' : '')
}
